import React from "react";
import { EXTRA_REPAYMENTS_ROUTE } from "../../route.constants";
import { ManageRepaymentsOption } from "../../../../manageRepaymentsOption";

export const MakeExtraRepaymentOptions = ({ accountId }) => {
  return (
    <>
      <h3>How will you pay?</h3>
      <p className="payment-options-subtitle">Please select a method to make your repayment.</p>
      <ul>
        <div className="payment-options-list">
          <li>
            <ManageRepaymentsOption
              accountId={accountId}
              title="Direct Debit"
              subRoute={EXTRA_REPAYMENTS_ROUTE.DIRECT_DEBIT}
            >
            </ManageRepaymentsOption>
          </li>
          <li>
            <ManageRepaymentsOption
              accountId={accountId}
              title="Debit Card"
              subRoute={EXTRA_REPAYMENTS_ROUTE.DEBIT_CARD}
            >
            </ManageRepaymentsOption>
          </li>
          <li>
            <ManageRepaymentsOption
              accountId={accountId}
              title="Bank Transfer"
              subRoute={EXTRA_REPAYMENTS_ROUTE.BANK_TRANSFER}
            >
            </ManageRepaymentsOption>
          </li>
        </div>
      </ul>
    </>
  );
};
